import { QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from '@tanstack/react-router'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { onSessionLost, queryClient } from './api/index'
import type { ProfileQuery } from './session/useSession'

// biome-ignore lint/suspicious/noExplicitAny: each surface's router is its own literal route tree
type AnyRouter = any

export function mount({
  profileQuery,
  buildRouter,
  signInPath = '/sign-in',
}: {
  profileQuery: ProfileQuery
  buildRouter: (client: typeof queryClient) => AnyRouter
  signInPath?: string
}) {
  queryClient.query(profileQuery).catch(() => undefined)

  const router = buildRouter(queryClient)

  onSessionLost(() => {
    router.navigate({ to: signInPath, replace: true })
  })

  const root = document.getElementById('root')

  if (root === null) throw new Error('missing #root')

  createRoot(root).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </StrictMode>,
  )
}
